import Vue from "vue";
import Router from "vue-router";
import userCenter from "@/components/common/UserCenter";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "userCenter",
      component: userCenter,
      redirect: "/dashboard", // 内蒙和新疆--天彩
      children: [
        // 1. 首页
        {
          path: "/dashboard",
          component: resolve =>
            require(["../components/page/Dashboard.vue"], resolve),
          meta: {
            title: "主界面"
          }
        },
        {
          path: "/yinhangindex",
          component: resolve =>
            require(["../components/page/yinhangindex.vue"], resolve),
          meta: {
            title: "投标银行保函"
          }
        },
        // 2. 列表页
        {
          path: "/dianzibaohan",
          component: resolve =>
            require(["../components/page/Dianzibaohan.vue"], resolve),
          meta: {
            title: "电子保函"
          }
        },
        // 2. 列表页
        {
            path: "/zhifushijianxuzhi",
            component: resolve =>
              require(["../components/page/zhifushijianxuzhi.vue"], resolve),
            meta: {
              title: "支付时间须知"
            }
          },
        // 2. 列表页
        {
          path: "/dianzibaohanyanshi",
          component: resolve =>
            require(["../components/page/DianzibaohanYanShi.vue"], resolve),
          meta: {
            title: "电子保函"
          }
        },
        // 3. 乌海-->首页--》基本信息页
        {
          path: "/baoxianBasic",
          component: resolve =>
            require(["../components/page/baoxianBasic.vue"], resolve),
          meta: {
            title: "保险保函-项目基本信息"
          }
        },
        // --- 原银行
        // {
        //     path: "/baoxianBasicxd1",
        //     component: resolve =>
        //       require(["../components/page/baoxianBasicxd1.vue"], resolve),
        //     meta: {
        //       title: "保险保函-项目基本信息"
        //     }
        // },
        // -- 原担保
        // {
        //     path: "/baoxianBasicxd2",
        //     component: resolve =>
        //       require(["../components/page/baoxianBasicxd2.vue"], resolve),
        //     meta: {
        //       title: "保险保函-项目基本信息"
        //     }
        // },
        // 添加的页面开始
        // 首页--》保险投保页面（通辽、呼伦贝尔、呼和浩特）
        {
          path: "/baoxian",
          component: resolve =>
            require(["../components/page/biao/baoxian.vue"], resolve),
          meta: {
            title: "保险"
          }
        },
        // 首页--》保险投保页面--》保险确认页面
        {
          path: "/baoxianok",
          component: resolve =>
            require(["../components/page/biao/baoxianok.vue"], resolve),
          meta: {
            title: "保险确认"
          }
        },
        {
          path: "/baoxiantiancaiok",
          component: resolve =>
            require(["../components/page/biao/baoxiantiancaiok.vue"], resolve),
          meta: {
            title: "保险确认"
          }
        },

        // 首页--》银行保函
        {
          path: "/yinhang",
          component: resolve =>
            require(["../components/page/biao/yinhang.vue"], resolve),
          meta: {
            title: "银行"
          }
        },
        // 首页--》担保保险页面（呼和浩特）
        {
          path: "/danbao",
          component: resolve =>
            require(["../components/page/biao/danbao.vue"], resolve),
          meta: {
            title: "担保"
          }
        },
        // 塔城(incmpid=13)专用合并投保页：进入后系统随机保险/担保并渲染对应表单
        {
          path: "/toubaoTC",
          component: resolve =>
            require(["../components/page/biao/toubaoTC.vue"], resolve),
          meta: {
            title: "投保"
          }
        },
        // 首页--》担保投保页面--》担保确认页面
        {
          path: "/danbaook",
          component: resolve =>
            require(["../components/page/biao/danbaook.vue"], resolve),
          meta: {
            title: "担保确认"
          }
        },
        // 首页--》担保投保页面--》担保确认页面
        {
          path: "/jinhanok",
          component: resolve =>
            require(["../components/page/biao/jinhanok.vue"], resolve),
          meta: {
            title: "担保确认"
          }
        },
        {
            path: "/xinjianggongbaook",
            component: resolve =>
              require(["../components/page/biao/xinjianggongbaook.vue"], resolve),
            meta: {
              title: "担保确认"
            }
          },
        // 添加的页面结束
        // 旧页面
        // {
        //     path: "/baoxianBasicdb",
        //     component: resolve =>
        //       require(["../components/page/baoxianBasicdb.vue"], resolve),
        //     meta: {
        //       title: "保险保函-项目基本信息"
        //     }
        //   },
        //   {
        //     path: "/baoxianBasicyh",
        //     component: resolve =>
        //       require(["../components/page/baoxianBasicyh.vue"], resolve),
        //     meta: {
        //       title: "保险保函-项目基本信息"
        //     }
        //   },
        //   {
        //     path: "/baoxianBasicxd",
        //     component: resolve =>
        //       require(["../components/page/baoxianBasicxd.vue"], resolve),
        //     meta: {
        //       title: "保险保函-项目基本信息"
        //     }
        //   },
      ]
    },

    // 乌海--》首页--》基本信息--》经办人
    {
      path: "/apply",
      component: resolve =>
        require(["../components/page/apply.vue"], resolve),
      meta: {
        title: "我要申请"
      }
    },

    // 乌海--》首页--》基本信息--》经办人--》提交经办人信息
    {
      path: "/applySubmission",
      component: resolve =>
        require(["../components/page/applySubmission.vue"], resolve),
      meta: {
        title: "提交申请"
      }
    },
    // 乌海--》首页--》基本信息--》经办人--》提交经办人信息-->投保须知
    {
      path: "/insurancePolicy",
      component: resolve =>
        require(["../components/page/insurancePolicy.vue"], resolve),
      meta: {
        title: "选择保险保单"
      }
    },
    // 呼伦贝尔首页
    {
      path: "/applyxd",
      component: resolve =>
        require(["../components/page/applyxd.vue"], resolve),
      meta: {
        title: "我要申请"
      }
    },
    // 呼伦贝尔首页--》呼伦贝尔---天彩
    {
      path: "/applyxdtiancaiok",
      component: resolve =>
        require(["../components/page/applyxdtiancaiok.vue"], resolve),
      meta: {
        title: "电子保函"
      }
    },
    // 呼伦贝尔首页--》呼伦贝尔享安
    {
      path: "/applyxdok",
      component: resolve =>
        require(["../components/page/applyxdok.vue"], resolve),
      meta: {
        title: "电子保函"
      }
    },
    // 呼伦贝尔首页--》呼伦贝尔列表页面
    {
      path: "/dianzibaohanhlbe",
      component: resolve =>
        require(["../components/page/Dianzibaohanhlbe.vue"], resolve),
      meta: {
        title: "电子保函"
      }
    },
    // // 4. 云南-->投保页面
    // {
    //   path: "/yunnan",
    //   component: resolve =>
    //     require(["../components/page/biao/yunnan.vue"], resolve),
    //   meta: {
    //     title: "保险保函-项目基本信息"
    //   }
    // },
    // // 4. 云南-->投保确认页面
    // {
    //   path: "/yunnanok",
    //   component: resolve =>
    //     require(["../components/page/biao/yunnanok.vue"], resolve),
    //   meta: {
    //     title: "保险保函-确认"
    //   }
    // },
    // 4.云南--》云南列表页面
    {
      path: "/dianzibaohanyunnan",
      component: resolve =>
        require(["../components/page/DianzibaohanYunNan.vue"], resolve),
      meta: {
        title: "电子保函"
      }
    },
    {
      path: "/orderPay",
      component: resolve =>
        require(["../components/page/OrderPay.vue"], resolve),
      meta: {
        title: "电子保函-支付"
      }
    },

    {
      path: "/orderFinish2",
      component: resolve =>
        require(["../components/page/OrderFinish2.vue"], resolve),
      meta: {
        title: "电子保函-已支付"
      }
    },
    {
      path: "/payAccount",
      component: resolve =>
        require(["../components/page/payAccount.vue"], resolve),
      meta: {
        title: "电子保函-支付"
      }
    },
    {
      path: "/payurl",
      component: resolve =>
        require(["../components/page/payurl.vue"], resolve),
      meta: {
        title: "插入页面"
      }
    },
    // --- 测试页面
    // {
    //   path: "/baoxian_ceshi",
    //   component: resolve =>
    //     require(["../components/page/biao/baoxian_ceshi.vue"], resolve),
    //   meta: {
    //     title: "测试图片的页面"
    //   }
    // },  
    {
      path: "/404",
      component: resolve => require(["../components/page/404.vue"], resolve)
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js